import React, { Component } from 'react';
import ActionFace from 'material-ui/svg-icons/action/face';
import ActionFavorite from 'material-ui/svg-icons/action/favorite';
import EditorAttachMoney from 'material-ui/svg-icons/editor/attach-money';

import HomeGalleryHeader from './HomeGalleryHeader';
import HomeGalleryFooter from './HomeGalleryFooter';
import { HowItWorksSection, HowItWorksItem } from './HowItWorks';
import HeroSection from './HeroSection';
import GetInTouchSection from './GetInTouchSection';
import { TestimonialSection, Testimonial, Divider } from './TestimonialSection';


const SectionDivider = (props) => (
  <hr style={{ borderTop: "1px solid #d9d9d9",
               margin: "0 auto",
               width: props.width? props.width : "100%" }} />
)

const iconStyle = {width: "48px", height: "48px", color: "rgb(84, 110, 122)"};

class ArtistHomepageContent extends React.Component {
  render() {
    return (
      <div>
        <HeroSection
          header="Home Gallery Project helps you show your artwork in homes, not in your basement. It's the best way to build an audience."
          image="https://firebasestorage.googleapis.com/v0/b/home-gallery-project.appspot.com/o/website%2Fcouch_background.jpg?alt=media&token=7932ebc8-b197-402e-aa52-ea289180e728" />

          <SectionDivider width="33%" />

        <HowItWorksSection text="How it works:" artists={true}>
          <HowItWorksItem icon={<ActionFace style={iconStyle} />} text="We match your art with interested customers." />
          <HowItWorksItem icon={<ActionFavorite style={iconStyle} />} text="Customers display your art in their home for a trial run—a chance for them to fall in love." />
          <HowItWorksItem icon={<EditorAttachMoney style={iconStyle} />} text="You get XX% of every sale." />
        </HowItWorksSection>
        <SectionDivider />


        <TestimonialSection>
          <Testimonial headline="This is both less work and cheaper than a gallery."
                       quote=""
                       attribution="" />
          <Divider />
          <Testimonial headline="I never imagined my artwork on display before this."
                       quote="While studying internationally and traveling for work, photography has been a big part of my life in trying to capture beauty along the way. Until this, I would never have imagined my work being on display and up for sale. It changes everything - and allows me to make money while doing a hobby I love."
                       attribution="Curt Lederle" />
           <Divider />
          <Testimonial headline="Selling my art is now effortless."
                       quote=""
                       attribution="" />
           <Divider />
          <Testimonial headline="What a great way to turn instagram followers into paid supporters."
                       quote=""
                       attribution="" />
         </TestimonialSection>
         <SectionDivider />

        <GetInTouchSection />
      </div>
    )
  }
}

class ArtistHomepage extends Component {
  render() {
    return (
      <div>
        <HomeGalleryHeader artists={true} />
        <div className="ArtistHomepage">
          <ArtistHomepageContent />
        </div>
        <HomeGalleryFooter />
      </div>
    );
  }
}

export default ArtistHomepage;



// WEBPACK FOOTER //
// ./src/ArtistHomePage.js